import { message, notification } from 'antd';

const DEFAULT_ERROR_MESSAGE = '请求失败，请稍后重试';

const readNestedMessage = (data: any): string | undefined => {
  if (!data) return undefined;
  if (typeof data === 'string') {
    const trimmed = data.trim();
    return trimmed || undefined;
  }
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error.trim();
  }
  return undefined;
};

export const extractErrorMessage = (
  error: any,
  fallback = DEFAULT_ERROR_MESSAGE,
): string => {
  const candidates = [
    error?.info?.errorMessage,
    readNestedMessage(error?.response?.data),
    error?.response?.data?.error,
    error?.message,
    fallback,
  ];

  const resolved = candidates.find(
    (item) => typeof item === 'string' && item.trim().length > 0,
  );

  return typeof resolved === 'string' ? resolved.trim() : fallback;
};

export const extractErrorCode = (error: any): string | number | undefined => {
  return (
    error?.info?.errorCode ??
    error?.response?.data?.code ??
    error?.response?.status ??
    undefined
  );
};

export const showErrorMessage = (error: any, fallback?: string) => {
  message.error(extractErrorMessage(error, fallback));
};

export const showErrorNotification = (
  error: any,
  fallback?: string,
  title = '请求失败',
) => {
  const code = extractErrorCode(error);
  const description = extractErrorMessage(error, fallback);
  notification.error({
    message: code ? `${title}（${code}）` : title,
    description,
    duration: 5,
  });
};
